"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var antd_1 = require("antd");
exports.default = styled_components_1.default(antd_1.Row)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin-bottom: 0.5em;\n"], ["\n  margin-bottom: 0.5em;\n"])));
var templateObject_1;
//# sourceMappingURL=index.js.map